@let cardsValue = cards();
@let availableProductsValue = availableProducts();
@let isLoadingValue = isLoading();
@let typeOfCardValue = typeOfCard();
@let radarValue = radar();
@let egpValue = egp();
@let egwValue = egw();
@let eppValue = epp();
@let smwValue = smw();
@let refreshValue = refresh();
@let nakedDashboardValue = nakedDashboard();

@if (!isLoadingValue) {
  <mat-drawer-container
    id="dashboard-drawer"
    autosize
    [ngClass]="nakedDashboardValue ? 'naked-container' : ''">
    <!-- Settings -->
    <mat-drawer #drawer class="settings-sidenav" mode="over" position="end">
      <ng-template #toggleButton>
        @if (!showSettings()) {
          <button
            mat-icon-button
            class="close-button"
            (click)="drawer.toggle()">
            <fa-icon [icon]="['far', 'times']"></fa-icon>
          </button>
        } @else {
          <button
            mat-icon-button
            class="close-button"
            (click)="closeCardSettings(); drawer.toggle()">
            <fa-icon [icon]="['far', 'chevron-left']"></fa-icon>
          </button>
        }
      </ng-template>
      @if (showSettings() && selectedDashboardCard()) {
        <ng-container
          *ngTemplateOutlet="
            dashboardCardSettingArea;
            context: { $implicit: toggleButton }
          "></ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            dashboardSettingArea;
            context: { $implicit: toggleButton }
          "></ng-container>
      }
    </mat-drawer>

    <div
      class="dashboard-context-menu-trigger"
      [style.left.px]="contextMenuPosition.x"
      [style.top.px]="contextMenuPosition.y"
      [matMenuTriggerFor]="dashboardCardContextMenu"
      #dashboardCardContextMenuTrigger="matMenuTrigger"></div>

    <mat-menu #dashboardCardContextMenu="matMenu">
      <button
        mat-menu-item
        (click)="openCardSettings(drawer, contextMenuCard())">
        <fa-icon [icon]="['far', 'cog']"></fa-icon>
        <span> Karte bearbeiten</span>
      </button>

      <button mat-menu-item (click)="onRemoveCard(contextMenuCard())">
        <fa-icon [icon]="['far', 'trash']"></fa-icon>
        <span> Karte entfernen</span>
      </button>
    </mat-menu>

    <div class="base-container">
      <!-- Wordpress Teaser -->
      @if (!nakedDashboardValue) {
        <!-- Wordpress Teaser -->
        <app-wordpress-teaser></app-wordpress-teaser>
      } @else {
        <mat-toolbar class="toolbar-naked">
          <img
            class="logo"
            alt="Logo"
            src="assets/brand/meteofocus-logo-350.png"
            height="36" />
          <span class="navbar-spacer"></span>
          <button mat-icon-button (click)="drawer.open()" color="primary">
            <fa-icon [icon]="['fal', 'cogs']"></fa-icon>
          </button>
          <!-- logout -->
          <button
            class="settings-sidenav__btn"
            mat-icon-button
            color="primary"
            [routerLink]="['/logout']"
            tp="{{ 'HOME.LOGOUT' | translate }}"
            variation="popper"
            trigger="mouseenter"
            tpPlacement="left">
            <fa-icon [icon]="['fal', 'sign-out']"></fa-icon>
          </button>
        </mat-toolbar>
      }
      <!-- Info -->
      <app-dashboard-info
        [refresh]="refreshValue.info.counter"></app-dashboard-info>
      <!-- Warnings -->
      <!--NOTE: for top cards components need to render mat-cards without component tag (would interfere with css) see EXAMPLE-->
      @if (topCards().length > 0 && !nakedDashboardValue) {
        <div class="dashboard-card-grid top-card">
          @for (card of topCards(); track $index) {
            @if (card === 'ampel') {
              <app-dashboard-ampel
                #dashboardAmpelComponent
                style="display: none"
                [isTopCard]="true"
                [refresh]="refreshValue.ampel.counter"
                (ampelDtg)="ampelDtg.set($event)"></app-dashboard-ampel>
              <ng-content
                *ngTemplateOutlet="
                  dashboardAmpelComponent.topCardsDashboardAmpelTemplate()
                "></ng-content>
            }

            @if (card === 'gmaAlarm') {
              <app-dashboard-gma-alarm
                #dashboardGmaAlarm
                [refresh]="refreshValue.smw.counter"
                style="display: none"></app-dashboard-gma-alarm>
              <ng-content
                *ngTemplateOutlet="
                  dashboardGmaAlarm.topCardsGmaAlarmTemplate()
                "></ng-content>
            }
          }
        </div>
      }
      <!-- Products -->
      <div
        class="dashboard-card-grid"
        cdkDropList
        cdkDropListOrientation="mixed"
        [cdkDropListData]="cardsValue"
        [cdkDropListDisabled]="isMobilePlatform()"
        (cdkDropListDropped)="onDrop($event)">
        @if (isSomethingOrdered()) {
          @if (cardsValue.length < 1 && !isLoadingValue) {
            <mat-card appearance="outlined" class="dashboard-card add-new">
              <button mat-fab (click)="drawer.open()" color="primary">
                <fa-icon [icon]="['far', 'cogs']" size="2x"></fa-icon>
              </button>
              <p>Übersichtsseite einrichten</p>
            </mat-card>
          }
          @for (card of cardsValue; track card) {
            @if (typeOfCardValue.hasOwnProperty(card)) {
              <mat-card
                cdkDrag
                [cdkDragDisabled]="isMobilePlatform()"
                appearance="outlined"
                class="dashboard-card"
                [ngClass]="[
                  'dashboard-card-' + typeOfCardValue[card],
                  typeOfCardValue[card] === 'egp' &&
                  egpValue[card]?.view === 'text'
                    ? 'dashboard-card-egp-text'
                    : '',
                ]"
                (contextmenu)="
                  openCardContextMenu(
                    $event,
                    card,
                    dashboardCardContextMenuTrigger
                  )
                ">
                <button
                  mat-icon-button
                  class="dashboard-card-drag-handle"
                  cdkDragHandle
                  type="button"
                  matTooltip="Karte verschieben"
                  aria-label="Karte verschieben">
                  <fa-icon [icon]="['far', 'grip-vertical']"></fa-icon>
                </button>

                <button
                  mat-icon-button
                  class="dashboard-card-menu-button"
                  type="button"
                  matTooltip="Karte verwalten"
                  aria-label="Karte verwalten"
                  [matMenuTriggerFor]="cardActionsMenu"
                  (click)="$event.stopPropagation()">
                  <fa-icon [icon]="['far', 'ellipsis-vertical']"></fa-icon>
                </button>
                <mat-menu #cardActionsMenu="matMenu">
                  <button
                    mat-menu-item
                    (click)="openCardSettings(drawer, card)">
                    <fa-icon [icon]="['far', 'cog']"></fa-icon>
                    <span> Karte bearbeiten</span>
                  </button>
                  <button mat-menu-item (click)="onRemoveCard(card)">
                    <fa-icon [icon]="['far', 'trash']"></fa-icon>
                    <span> Karte entfernen</span>
                  </button>
                </mat-menu>

                @let routeOfCardValue = routeOfCard();
                <mat-card-header
                  [ngClass]="
                    routeOfCardValue.hasOwnProperty(card)
                      ? 'with-link'
                      : 'without-link'
                  "
                  (click)="
                    routeOfCardValue.hasOwnProperty(card)
                      ? onNavigateTo(routeOfCardValue[card])
                      : null
                  ">
                  @if (typeOfCardValue[card] === 'epp') {
                    @let eppLastIssueTimesValue = eppLastIssueTimes();
                    @if (eppLastIssueTimesValue[card]) {
                      <div class="dashboard-updated-chip">
                        <fa-icon [icon]="['far', 'clock']"></fa-icon>
                        {{
                          eppLastIssueTimesValue[card]
                            | datex: 'DD.MM. HH:mm' : undefined : getLanguage
                        }}
                      </div>
                    }
                  }
                  @if (typeOfCardValue[card] === 'radar') {
                    @let radarDtgValue = radarDtg();
                    @if (
                      radarValue &&
                      radarValue.hasOwnProperty(card) &&
                      radarDtgValue[radarValue[card].region]
                    ) {
                      <span class="dashboard-updated-chip">
                        <fa-icon [icon]="['far', 'clock']"></fa-icon>
                        {{
                          (radarDtgValue[radarValue[card].region] | moment)
                            .local()
                            .format('DD.MM. HH:mm')
                        }}
                      </span>
                    }
                  }

                  <mat-card-title class="two-row-title">
                    <span class="title-main">
                      {{
                        'HOME.DASHBOARD.PRODUCT.' +
                          (typeOfCardValue[card] | uppercase) | translate
                      }}
                    </span>
                    @if (typeOfCardValue[card] === 'radar') {
                      <span class="title-sub">
                        {{
                          'PRODUCT.RADAR.REGIONS.' + radarValue[card]?.region
                            | translate
                        }}
                      </span>
                    }
                  </mat-card-title>
                  <mat-card-subtitle
                    [ngStyle]="{
                      width:
                        cardConfig[typeOfCardValue[card]]['width'] - 90 + 'px',
                    }">
                    @switch (typeOfCardValue[card]) {
                      @case ('egp') {
                        @let egpValue = egp();
                        @if (egpValue) {
                          @if (egpValue.hasOwnProperty(card)) {
                            @let cfg = egpValue[card];
                            <fa-icon
                              [icon]="[
                                'far',
                                egpViewIcons[cfg.view ?? 'riskbox'],
                              ]">
                            </fa-icon>
                            {{ [cfg.name] }}
                          }
                        }
                      }
                      @case ('epp') {
                        @let eppValue = epp();
                        @if (eppValue) {
                          @if (eppValue.hasOwnProperty(card)) {
                            {{ eppValue[card].station.overwriteStationName }}
                          }
                        }
                        @if (typeOfCardValue[card] === 'epp') {
                          <span class="title-sub">
                            [{{
                              'PRODUCT.EPP.PARAMETERSET.SETS.' +
                                eppValue[card].parameterset | translate
                            }}]
                          </span>
                        }
                      }
                      @case ('smw') {
                        @let statType = card.substr(4);
                        @if (smwValue[card]) {
                          {{
                            'PRODUCT.SMW.STATIONTYPE.' + (statType | uppercase)
                              | translate
                          }}
                        }
                      }
                      @case ('ampel') {
                        @let ampelDtgValue = ampelDtg();
                        @if (ampelDtgValue) {
                          <div class="dashboard-updated-chip">
                            <fa-icon [icon]="['far', 'clock']"></fa-icon>
                            {{ (ampelDtgValue | moment).format('DD.MM HH:mm') }}
                          </div>
                        }
                      }
                      @case ('egw') {
                        @let egwValue = egw();
                        @if (egwValue.hasOwnProperty(card)) {
                          {{ egwValue[card].name }}
                        }
                      }
                      @case ('dwd') {
                        {{ 'PRODUCT.DWD.SUBTITLE' | translate }}
                      }
                      @case ('warnmap') {
                        @let source = card.split('_')[1];

                        {{
                          'PRODUCT.DETAILS.WARNMAP.SOURCES.' + source
                            | translate
                        }}
                      }
                      @default {
                        {{ '' }}
                      }
                    }
                  </mat-card-subtitle>
                  <fa-icon
                    mat-card-avatar
                    [icon]="['far', cardConfig[typeOfCardValue[card]].icon]"
                    size="2x"></fa-icon>
                </mat-card-header>
                @let radarDtgValue = radarDtg();
                @switch (typeOfCardValue[card]) {
                  @case ('radar') {
                    @if (
                      radarValue &&
                      radarValue.hasOwnProperty(card) &&
                      radarDtgValue.hasOwnProperty(radarValue[card].region)
                    ) {
                      <app-dashboard-radar
                        [settings]="radarValue[card]"
                        [radarDtg]="
                          radarDtgValue[radarValue[card].region]
                        "></app-dashboard-radar>
                    }
                  }
                  @case ('warnmap') {
                    @let warnmapValue = warnmap();
                    @if (warnmapValue && warnmapValue.hasOwnProperty(card)) {
                      <app-dashboard-warnmap
                        [source]="warnmapValue[card].source"
                        [parameter]="
                          warnmapValue[card].parameter
                        "></app-dashboard-warnmap>
                    }
                  }
                  @case ('egp') {
                    @if (egpValue && egpValue.hasOwnProperty(card)) {
                      <app-dashboard-egp
                        [egpConfig]="egpValue[card]"
                        [refresh]="refreshValue.egp.counter">
                      </app-dashboard-egp>
                    }
                  }
                  @case ('egw') {
                    @if (egwValue && egwValue.hasOwnProperty(card)) {
                      <app-dashboard-warning
                        [egwConfig]="egwValue[card]"
                        [isTopCard]="false"
                        [refresh]="refreshValue.warn.counter">
                      </app-dashboard-warning>
                    }
                  }
                  @case ('epp') {
                    @if (eppValue && eppValue.hasOwnProperty(card)) {
                      <app-dashboard-epp
                        [eppConfig]="eppValue[card]"
                        [refresh]="refreshValue.epp.counter"
                        (lastIssueTimeChange)="
                          onEppLastIssueTimeChange(card, $event)
                        ">
                      </app-dashboard-epp>
                    }
                  }
                  @case ('smw') {
                    <app-dashboard-smw
                      [smwConfig]="smwValue[card]"
                      [refresh]="refreshValue.smw.counter"></app-dashboard-smw>
                  }
                  @case ('ampel') {
                    <app-dashboard-ampel
                      [isTopCard]="false"
                      [refresh]="refreshValue.ampel.counter"
                      (ampelDtg)="ampelDtg.set($event)"></app-dashboard-ampel>
                  }
                  @case ('dwd') {
                    <img
                      [src]="safeUrlDwdMap()"
                      style="display: block; margin: auto" />
                    <img
                      src="/assets/images/dwd_logo.png"
                      style="position: absolute; right: 12px; bottom: 12px" />
                  }
                }
              </mat-card>
            }
          }
        }

        <mat-card
          appearance="outlined"
          class="dashboard-card dashboard-card-placeholder"
          (click)="openAddCardSettings(drawer)">
          <div class="dashboard-card-placeholder-content">
            <div class="dashboard-card-placeholder-icon">
              <fa-icon [icon]="['far', 'plus']"></fa-icon>
            </div>
            <h3>{{ 'HOME.DASHBOARDCFG.ADDPRODUCTS' | translate }}</h3>
            <p>{{ 'HOME.DASHBOARDCFG.ADDPRODUCTS_SUBTEXT' | translate }}</p>
          </div>
        </mat-card>
      </div>
    </div>

    @if (!nakedDashboardValue) {
      <!-- SIDENAV SETTINGS -->
      <div class="settings-button-stack">
        <!--settings button-->
        <button
          class="settings-button"
          mat-mini-fab
          (click)="drawer.toggle()"
          tp="{{ 'HOME.SETTINGS' | translate }}"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="left">
          <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
        </button>
        <!--feedback button-->
        <button
          class="settings-button settings-button--feedback"
          mat-mini-fab
          (click)="onSendMail()"
          tp="{{ 'HOME.FEEDBACK' | translate }}"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="left">
          <fa-icon [icon]="['far', 'paper-plane']" size="lg"></fa-icon>
        </button>
        <!-- <app-print-button></app-print-button> -->
      </div>
    }
  </mat-drawer-container>
} @else {
  <app-loading-overlay text="Dashboard wird geladen..."></app-loading-overlay>
}
<!-- Settings -->
<ng-template #dashboardSettingArea let-toggleButton>
  <h3 class="settings-area-title">
    <span>
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
      &nbsp; {{ 'HOME.SETTINGS' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
  </h3>
  <!-- Cards on Dashboard -->
  <mat-card appearance="outlined" class="dashboard-config-card">
    <p>
      <fa-icon [icon]="['far', 'home']" size="lg"></fa-icon>
      &nbsp;<b>{{ 'HOME.DASHBOARDCFG.ELEMENTSLIST' | translate }}</b>
    </p>
    <p>{{ 'HOME.DASHBOARDCFG.ELEMENTSTEXT' | translate }}</p>
    <mat-accordion
      class="accordion-headers-align"
      cdkDropList
      [cdkDropListData]="cardsValue"
      (cdkDropListDropped)="onDrop($event)"
      #accordionEdit="matAccordion">
      @for (card of cardsValue; track $index) {
        @let isMobilePlatformValue = isMobilePlatform();
        <mat-expansion-panel cdkDrag>
          <mat-expansion-panel-header
            [collapsedHeight]="isMobilePlatformValue ? '60px' : '48px'"
            [expandedHeight]="isMobilePlatformValue ? '60px' : '48px'">
            <mat-panel-title class="panel-title-row">
              <fa-icon
                cdkDragHandle
                class="panel-drag-handle"
                [icon]="['far', 'bars']"
                matTooltip="Karte verschieben"
                (click)="$event.stopPropagation()"></fa-icon>
              <span class="panel-title-text">
                <span class="panel-title-primary">
                  {{
                    'PRODUCT.' + (typeOfCardValue[card] | uppercase) + '.TITLE'
                      | translate
                  }}
                </span>
                <span class="panel-title-secondary">
                @switch (typeOfCardValue[card]) {
                  @case ('radar') {
                    @let radarValue = radar();
                    @if (radarValue) {
                      @if (radarValue.hasOwnProperty(card)) {
                        @let region = radarValue[card].region;
                        @let zoomPointName =
                          radarValue[card].zoomPoint.searchName;
                        @let regionTranslation =
                          'PRODUCT.RADAR.REGIONS.' + region | translate;
                        @let zoomValue =
                          zoomPointName === 'whole Area'
                            ? ''
                            : ' - Zoom auf ' + zoomPointName;
                        {{ regionTranslation + zoomValue }}
                      }
                    }
                  }
                  @case ('egp') {
                    @let egpValue = egp();
                    @if (egpValue) {
                      @if (egpValue.hasOwnProperty(card)) {
                        {{ egpValue[card].name }}
                      }
                    }
                  }
                  @case ('egw') {
                    @let egwValue = egw();
                    @if (egwValue) {
                      @if (egwValue.hasOwnProperty(card)) {
                        {{ egwValue[card].name }}
                      }
                    }
                  }
                  @case ('epp') {
                    @let eppValue = epp();
                    @if (eppValue) {
                      @if (eppValue.hasOwnProperty(card)) {
                        @let viewIcon =
                          {
                            meteogram: 'analytics',
                            table: 'th',
                          };
                        @let cfg = eppValue[card];

                        <fa-icon [icon]="['far', viewIcon[cfg.view]]">
                        </fa-icon>
                        {{
                          [
                            cfg.station.overwriteStationName,
                            'PRODUCT.EPP.PARAMETERSET.SETS.' + cfg.parameterset
                              | translate,
                            cfg.resolution.days +
                              ' ' +
                              ('PRODUCT.EPP.RESOLUTION.DAYS' | translate),
                          ].join(' - ')
                        }}
                      }
                    }
                  }
                  @case ('smw') {
                    @let statType = card.substr(4);
                    @if (smwValue[card]) {
                      {{
                        'PRODUCT.SMW.STATIONTYPE.' + (statType | uppercase)
                          | translate
                      }}
                    }
                  }
                }
                </span>
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @switch (typeOfCardValue[card]) {
            @case ('radar') {
              <ng-container
                *ngTemplateOutlet="
                  cfgRadar;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('egp') {
              <ng-container
                *ngTemplateOutlet="
                  cfgEgp;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('egw') {
              <ng-container
                *ngTemplateOutlet="
                  cfgEgw;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('smw') {
              <ng-container
                *ngTemplateOutlet="
                  cfgSmw;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('epp') {
              <ng-container
                *ngTemplateOutlet="
                  cfgEpp;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('ampel') {
              <ng-container
                *ngTemplateOutlet="
                  cfgAmpel;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('dwd') {
              <ng-container
                *ngTemplateOutlet="
                  cfgDwd;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
            @case ('warnmap') {
              <ng-container
                *ngTemplateOutlet="
                  cfgWarnmap;
                  context: { $implicit: { card: card, action: 'edit' } }
                "></ng-container>
            }
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-card>
  <br />
  <!-- Cards to add -->
  <mat-card appearance="outlined" class="dashboard-config-card">
    <p>
      <b>
        <fa-icon [icon]="['far', 'plus-square']" size="lg"></fa-icon>
        &nbsp;{{ 'HOME.DASHBOARDCFG.ADDPRODUCTS' | translate }}</b
      >
    </p>
    <p>{{ 'HOME.DASHBOARDCFG.ADDTEXT' | translate }}</p>
    <mat-accordion class="accordion-headers-align" #accordionAdd="matAccordion">
      @for (product of availableProductsValue | key; track $index) {
        @if (
          (product === 'radar' &&
            (availableProductsValue[product] | keyvalue).length > 0) ||
          (product !== 'radar' && availableProductsValue[product].length > 0) ||
          (product === 'warnmap' &&
            (availableProductsValue[product] | keyvalue).length > 0) ||
          (product !== 'warnmap' && availableProductsValue[product].length > 0)
        ) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'PRODUCT.' + (product | uppercase) + '.TITLE' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @switch (product) {
              @case ('radar') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgRadar;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('egp') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgEgp;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('egw') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgEgw;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('epp') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgEpp;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('ampel') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgAmpel;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('smw') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgSmw;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('dwd') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgDwd;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
              @case ('warnmap') {
                <ng-container
                  *ngTemplateOutlet="
                    cfgWarnmap;
                    context: { $implicit: { card: product, action: 'add' } }
                  "></ng-container>
              }
            }
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  </mat-card>
</ng-template>

<ng-template #dashboardCardSettingArea let-toggleButton>
  @let selectedCard = selectedDashboardCard();
  @let selectedCardType = typeOfCard()[selectedCard];

  <h3 class="settings-area-title">
    <span>
      <fa-icon [icon]="['far', 'cog']" size="lg"></fa-icon>
      &nbsp; Karte bearbeiten
    </span>
    <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
  </h3>

  <mat-card appearance="outlined" class="dashboard-config-card">
    <p>
      <fa-icon
        [icon]="['far', cardConfig[selectedCardType]?.icon ?? 'square']"
        size="lg"></fa-icon>
      &nbsp;
      <b>
        {{
          'HOME.DASHBOARD.PRODUCT.' + (selectedCardType | uppercase) | translate
        }}
      </b>
    </p>

    @switch (selectedCardType) {
      @case ('radar') {
        <ng-container
          *ngTemplateOutlet="
            cfgRadar;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('egp') {
        <ng-container
          *ngTemplateOutlet="
            cfgEgp;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('egw') {
        <ng-container
          *ngTemplateOutlet="
            cfgEgw;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('epp') {
        <ng-container
          *ngTemplateOutlet="
            cfgEpp;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('smw') {
        <ng-container
          *ngTemplateOutlet="
            cfgSmw;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('ampel') {
        <ng-container
          *ngTemplateOutlet="
            cfgAmpel;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('dwd') {
        <ng-container
          *ngTemplateOutlet="
            cfgDwd;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
      @case ('warnmap') {
        <ng-container
          *ngTemplateOutlet="
            cfgWarnmap;
            context: { $implicit: { card: selectedCard, action: 'edit' } }
          "></ng-container>
      }
    }
  </mat-card>
</ng-template>

<!-- DWD -->
<ng-template #cfgDwd let-cfg>
  @if (cfg.action === 'add') {
    <mat-form-field appearance="fill">
      <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
      <mat-select
        [formControl]="positionSelectControls.dwd"
        [placeholder]="'HOME.DASHBOARDCFG.POSITION' | translate">
        @for (card of cardsValue; track $index; let i = $index) {
          <mat-option [value]="i">{{ i + 1 }}</mat-option>
        }
        <mat-option [value]="cardsValue.length">
          {{ cardsValue.length + 1 }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  }
  @if (cfg.action === 'add') {
    <button
      mat-mini-fab
      color="primary"
      (click)="onAddDwd()"
      class="save-settings-button"
      [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
      [disabled]="cardsValue.indexOf(cfg.card) >= 0">
      <fa-icon
        [icon]="['far', cfg.action === 'edit' ? 'check' : 'plus']"></fa-icon>
    </button>
  }
  @if (cfg.action === 'edit') {
    <button
      mat-mini-fab
      color="warn"
      (click)="onRemoveCard(cfg.card)"
      class="save-settings-button"
      [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
      <fa-icon [icon]="['far', 'trash']"></fa-icon>
    </button>
  }
</ng-template>

<!-- WARNMAP -->
<ng-template #cfgWarnmap let-cfg>
  @let warnmapSourceSelectControlsValue = warnmapSourceSelectControls();
  @if (warnmapSourceSelectControlsValue[cfg.card]) {
    <div class="cfg-form-line">
      <mat-form-field appearance="fill" class="select-large">
        <mat-label
          >{{ 'PRODUCT.DETAILS.WARNMAP.SOURCES.select' | translate }}
        </mat-label>
        <mat-select
          [formControl]="warnmapSourceSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.DETAILS.WARNMAP.SOURCES.select' | translate">
          @for (source of availableProductsValue.warnmap | key; track $index) {
            <mat-option [value]="source">
              {{ 'PRODUCT.DETAILS.WARNMAP.SOURCES.' + source | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        false && warnmapSourceSelectControlsValue.hasOwnProperty('warnmap')
      ) {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'PRODUCT.WARNING.select' | translate }}</mat-label>
          <mat-select
            [formControl]="warnmapParameterSelectControls()[cfg.card]"
            [placeholder]="'PRODUCT.WARNING.select' | translate">
            @for (
              parameter of availableProductsValue.warnmap[
                warnmapSourceSelectControlsValue[cfg.card].value
              ];
              track $index
            ) {
              <mat-option [value]="parameter">
                {{ parameter }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls.dwd"
            [placeholder]="'HOME.DASHBOARDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length"
              >{{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }
      <button
        mat-mini-fab
        color="primary"
        [disabled]="!warnmapSourceSelectControlsValue[cfg.card].value"
        (click)="onSaveWarnmapCfg(cfg.card, cfg.action)"
        class="save-settings-button"
        [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate">
        <fa-icon
          [icon]="['far', cfg.action === 'edit' ? 'check' : 'plus']"></fa-icon>
      </button>
      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </div>
  }
</ng-template>

<!-- Ampel -->
<ng-template #cfgAmpel let-cfg>
  @if (cfg.action === 'add') {
    <mat-form-field appearance="fill">
      <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
      <mat-select
        [formControl]="positionSelectControls.ampel"
        [placeholder]="'HOME.DASHBOARDCFG.POSITION' | translate">
        @for (card of cardsValue; track $index; let i = $index) {
          <mat-option [value]="i">{{ i + 1 }}</mat-option>
        }
        <mat-option [value]="cardsValue.length">
          {{ cardsValue.length + 1 }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button
      mat-mini-fab
      color="primary"
      (click)="onAddAmpel()"
      class="save-settings-button"
      [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
      [disabled]="cardsValue.indexOf(cfg.card) >= 0">
      <fa-icon
        [icon]="['far', cfg.action === 'edit' ? 'check' : 'plus']"></fa-icon>
    </button>
  }
  @if (cfg.action === 'edit') {
    <button
      mat-mini-fab
      color="warn"
      (click)="onRemoveCard(cfg.card)"
      class="save-settings-button"
      [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
      <fa-icon [icon]="['far', 'trash']"></fa-icon>
    </button>
  }
</ng-template>

<!-- RADAR -->
<ng-template #cfgRadar let-cfg>
  @if (radarValue) {
    <div class="cfg-form-line">
      @let radarRegionSelectControlValue = radarRegionSelectControl();
      @if ((availableProductsValue.radar | keyvalue).length > 0) {
        <mat-form-field appearance="fill">
          <mat-label
            >{{ 'PRODUCT.RADAR.REGIONS.SELECT' | translate }}
          </mat-label>
          <mat-select
            [formControl]="radarRegionSelectControlValue[cfg.card]"
            [value]="radarValue[cfg.card]?.region"
            [placeholder]="'PRODUCT.RADAR.REGIONS.SELECT' | translate">
            @for (region of availableProductsValue.radar | key; track $index) {
              <mat-option [value]="region">
                {{ 'PRODUCT.RADAR.REGIONS.' + region | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.RADAR.ZOOM' | translate }}</mat-label>
        <mat-select
          [formControl]="radarZoomSelectControl()[cfg.card]"
          [value]="radarValue[cfg.card]?.zoomPoint.searchName"
          [placeholder]="'PRODUCT.RADAR.ZOOM' | translate">
          @for (
            zoomPoint of availableProductsValue.radar[
              radarRegionSelectControlValue[cfg.card].value
            ];
            track $index
          ) {
            <mat-option [value]="zoomPoint['searchName']">
              {{
                zoomPoint['searchName'] === 'whole Area'
                  ? ('PRODUCT.RADAR.REGIONCENTER.' +
                      radarRegionSelectControlValue[cfg.card].value | translate)
                  : zoomPoint['searchName']
              }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls['radar']"
            [placeholder]="'HOME.DASHBOARDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length">
              {{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }
      <button
        mat-mini-fab
        color="primary"
        (click)="onSaveRadarSettings(cfg.card, cfg.action)"
        class="save-settings-button"
        [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate">
        <fa-icon
          [icon]="['far', cfg.action === 'edit' ? 'check' : 'plus']"></fa-icon>
      </button>
      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </div>
  }
</ng-template>

<!-- EGP -->
<ng-template #cfgEgp let-cfg>
  @let egpRegionSelectControlsValue = egpRegionSelectControls();
  @let egpViewSelectControlsValue = egpViewSelectControls();

  @if (egpRegionSelectControlsValue.hasOwnProperty(cfg.card)) {
    <div class="cfg-form-line">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.WARNING.select' | translate }}</mat-label>
        <mat-select
          [formControl]="egpRegionSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.WARNING.select' | translate">
          @for (egpProduct of availableProductsValue.egp; track $index) {
            <mat-option
              [value]="egpProduct.season + '_' + egpProduct.region"
              [disabled]="
                cfg.action === 'add' &&
                cardsValue.indexOf(
                  'egp_' + egpProduct.season + '_' + egpProduct.region
                ) >= 0 &&
                cardsValue.indexOf(
                  'egp_text_' + egpProduct.season + '_' + egpProduct.region
                ) >= 0
              ">
              {{ egpProduct.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (egpViewSelectControlsValue.hasOwnProperty(cfg.card)) {
        <mat-form-field appearance="fill">
          <mat-label>Darstellung</mat-label>
          <mat-select
            [formControl]="egpViewSelectControlsValue[cfg.card]"
            placeholder="Darstellung">
            <mat-option value="riskbox">
              <fa-icon matListItemIcon [icon]="['far', egpViewIcons.riskbox]">
              </fa-icon>
              Risikobox
            </mat-option>
            <mat-option value="text">
              <fa-icon matListItemIcon [icon]="['far', egpViewIcons.text]">
              </fa-icon>
              Risikobox + Text
            </mat-option>
          </mat-select>
        </mat-form-field>
      }

      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls['egp']"
            [placeholder]="'HOME.DASHBORDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length">
              {{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }

      @if (cfg.action === 'add' || availableProductsValue.egp.length > 1) {
        <button
          mat-mini-fab
          color="primary"
          (click)="onSaveEgpSettings(cfg.card, cfg.action)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
          [disabled]="
            availableProductsValue.egp.length < 1 ||
            egpRegionSelectControlsValue[cfg.card].invalid ||
            egpViewSelectControlsValue[cfg.card].invalid
          ">
          <fa-icon
            [icon]="[
              'far',
              cfg.action === 'edit' ? 'check' : 'plus',
            ]"></fa-icon>
        </button>
      }

      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="primary"
          (click)="onSaveEgpSettings(cfg.card, cfg.action)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
          [disabled]="
            availableProductsValue.egp.length < 1 ||
            egpRegionSelectControlsValue[cfg.card].invalid ||
            egpViewSelectControlsValue[cfg.card].invalid
          ">
          <fa-icon
            [icon]="[
              'far',
              cfg.action === 'edit' ? 'check' : 'plus',
            ]"></fa-icon>
        </button>
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </div>
  }
</ng-template>

<!-- EGW -->
<ng-template #cfgEgw let-cfg>
  @let egwRegionSelectControlsValue = egwRegionSelectControls();
  @if (egwRegionSelectControlsValue.hasOwnProperty(cfg.card)) {
    <div class="cfg-form-line">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.WARNING.select' | translate }}</mat-label>
        <mat-select
          [formControl]="egwRegionSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.WARNING.select' | translate">
          @for (egwProduct of availableProductsValue.egw; track $index) {
            <mat-option
              [value]="egwProduct.season + '_' + egwProduct.region"
              [disabled]="
                cardsValue.indexOf(egwProduct.card) >= 0 &&
                egwValue.hasOwnProperty(cfg.card) &&
                egwProduct.region !== egwValue[cfg.card].region
              ">
              {{ egwProduct.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls['egw']"
            [placeholder]="'HOME.DASHBORDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length">
              {{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }
      @if (cfg.action === 'add' || availableProductsValue.egw.length > 1) {
        <button
          mat-mini-fab
          color="primary"
          (click)="onSaveEgwSettings(cfg.card, cfg.action)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
          [disabled]="
            (cfg.action === 'add' &&
              cardsValue.indexOf(
                'egw_' + egwRegionSelectControlsValue[cfg.card].value
              ) >= 0) ||
            availableProductsValue.egw.length < 1 ||
            egwRegionSelectControlsValue[cfg.card].invalid
          ">
          <fa-icon
            [icon]="[
              'far',
              cfg.action === 'edit' ? 'check' : 'plus',
            ]"></fa-icon>
        </button>
      }
      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </div>
  }
</ng-template>

<!-- SMW -->
<ng-template #cfgSmw let-cfg>
  @let smwRegionSelectControlsValue = smwRegionSelectControls();
  @if (smwRegionSelectControlsValue.hasOwnProperty(cfg.card)) {
    <div class="cfg-form-line">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.SMW.stationType' | translate }}</mat-label>
        <mat-select
          [formControl]="smwRegionSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.SMW.stationType' | translate">
          @for (statType of availableProductsValue.smw; track $index) {
            <mat-option
              [value]="statType"
              [disabled]="cardsValue.indexOf('smw_' + statType) >= 0">
              {{
                'PRODUCT.SMW.STATIONTYPE.' + (statType | uppercase) | translate
              }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls['smw']"
            [placeholder]="'HOME.DASHBORDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length">
              {{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button
          mat-mini-fab
          color="primary"
          (click)="onSaveSmwSettings(cfg.card, cfg.action)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
          [disabled]="
            (cfg.action === 'add' &&
              smwRegionSelectControlsValue[cfg.card].invalid) ||
            cardsValue.indexOf(
              'smw_' + smwRegionSelectControlsValue[cfg.card].value
            ) >= 0
          ">
          <fa-icon
            [icon]="[
              'far',
              cfg.action === 'edit' ? 'check' : 'plus',
            ]"></fa-icon>
        </button>
      }
      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </div>
  }
</ng-template>

<!-- EPP -->
<ng-template #cfgEpp let-cfg>
  <div class="cfg-form-line">
    <form>
      @let eppViewSelectControlsValue = eppViewSelectControls();
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.EPP.VIEW.SELECT' | translate }}</mat-label>
        <mat-select
          [formControl]="eppViewSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.EPP.VIEW.SELECT' | translate">
          @for (view of ['meteogram', 'table']; track $index) {
            <mat-option [value]="view">
              <fa-icon
                matListItemIcon
                [icon]="['far', eppViewIcons[view]]"></fa-icon>
              {{ 'PRODUCT.EPP.VIEW.' + (view | uppercase) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @let eppStationSelectControlsValue = eppStationSelectControls();
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.EPP.SELECTSTATION' | translate }}</mat-label>
        <mat-select
          [formControl]="eppStationSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.EPP.SELECTSTATION' | translate">
          @for (
            station of availableProductsValue.epp[0]['stations'];
            track $index
          ) {
            <mat-option [value]="station['stationId']">
              {{ station['overwriteStationName'] }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @let eppParametersetSelectControlsValue = eppParametersetSelectControls();
      <mat-form-field appearance="fill">
        <mat-label
          >{{ 'PRODUCT.EPP.PARAMETERSET.SELECT' | translate }}
        </mat-label>
        <mat-select
          [formControl]="eppParametersetSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.EPP.PARAMETERSET.SELECT' | translate">
          @for (
            parameterset of availableProductsValue.epp[0]['parametersets'];
            track $index
          ) {
            <mat-option [value]="parameterset">
              {{ 'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @let eppResolutionSelectControlsValue = eppResolutionSelectControls();
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.EPP.RESOLUTION.SELECT' | translate }}</mat-label>
        <mat-select
          [formControl]="eppResolutionSelectControlsValue[cfg.card]"
          [placeholder]="'PRODUCT.EPP.RESOLUTION.SELECT' | translate">
          @for (
            resolution of availableProductsValue.epp[0]['resolutions'];
            track $index
          ) {
            <mat-option [value]="resolution['days']">
              {{ resolution['days'] }}
              {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (cfg.action === 'add') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'HOME.DASHBOARDCFG.POSITION' | translate }}</mat-label>
          <mat-select
            [formControl]="positionSelectControls['epp']"
            [placeholder]="'HOME.DASHBORDCFG.POSITION' | translate">
            @for (card of cardsValue; track $index; let i = $index) {
              <mat-option [value]="i">{{ i + 1 }}</mat-option>
            }
            <mat-option [value]="cardsValue.length">
              {{ cardsValue.length + 1 }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }
      <button
        mat-mini-fab
        color="primary"
        (click)="onSaveEppSettings(cfg.card, cfg.action)"
        class="save-settings-button"
        [matTooltip]="'HOME.DASHBOARDCFG.APPLY' | translate"
        [disabled]="
          eppViewSelectControlsValue[cfg.card].invalid ||
          eppStationSelectControlsValue[cfg.card].invalid ||
          eppParametersetSelectControlsValue[cfg.card].invalid ||
          eppResolutionSelectControlsValue[cfg.card].invalid
        ">
        <fa-icon
          [icon]="['far', cfg.action === 'edit' ? 'check' : 'plus']"></fa-icon>
      </button>
      @if (cfg.action === 'edit') {
        <button
          mat-mini-fab
          color="warn"
          (click)="onRemoveCard(cfg.card)"
          class="save-settings-button"
          [matTooltip]="'HOME.DASHBOARDCFG.REMOVE' | translate">
          <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
      }
    </form>
  </div>
</ng-template>
